<template>
  <!-- breadcrumbs -->
  <div class="breadcrumbs bg-primary-faded py-3">
    <div class="container px-4 px-sm-3">
      <div class="row">
        <div class="col-12">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0">
              <li class="breadcrumb-item">
                <router-link to="/">gbin.info</router-link>
              </li>

              <template v-if="props.filter">
                <li class="breadcrumb-item">
                  <router-link :to="`/brands`">
                    {{ props.pageName }}
                  </router-link>
                </li>

                <li class="breadcrumb-item active" aria-current="page">
                  <span class="text-capitalize">{{ props.filter }}</span>
                </li>
              </template>

              <li
                v-else-if="props.brandName"
                class="breadcrumb-item active"
                aria-current="page"
              >
                {{ props.brandName }}
              </li>

              <li v-else class="breadcrumb-item active" aria-current="page">
                {{ props.pageName }}
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <!-- /breadcrumbs -->
</template>

<script setup>
import { defineProps } from "vue";

const props = defineProps({
  pageName: String,
  filter: String,
  brandName: String,
});
</script>
